import MedicationMeasure from './MedicationMeasure.jsx';

export default MedicationMeasure;